import { IRootState } from '../../../store'
import { IServiceList } from '../store/serviceSelection.types'

export const getServicesSelector = (state: IRootState): IServiceList => state.services.services
